import Swiper, { Navigation, Pagination } from 'swiper';

const AdoptionCarousel = function () {    

    Swiper.use( Navigation, Pagination );

    const adoptionCarouselSwiper = document.querySelectorAll( '.swiper-adoption-carousel' );
    let swiperAdoption;
    // loop through swiper sections and init Swiper
    if ( Object.keys(adoptionCarouselSwiper).length ) {
        adoptionCarouselSwiper.forEach( function( el ){
            const buttonNext = el.querySelector('.swiper-button-next');
            const buttonPrev = el.querySelector('.swiper-button-prev');
            swiperAdoption = new Swiper( el , {
                direction: 'horizontal',
                spaceBetween: 20,
                slidesPerView: "auto",
                loop: false,
                initialSlide: 0,
                navigation: {
                    nextEl: buttonNext,
                    prevEl: buttonPrev,
                },
            })  
        });
    }

    
    const adoptionModal = document.querySelectorAll( '.modal-adoption-swiper' );
    if ( Object.keys(adoptionModal).length ) {
        adoptionModal.forEach(image => {
            const pagination = image.querySelector('.swiper-pagination');
            const buttonNext = image.querySelector('.swiper-button-next');
            const buttonPrev = image.querySelector('.swiper-button-prev');
            const swiperModal = new Swiper( image , {
                modules: [Pagination],
                direction: 'horizontal',
                spaceBetween: 20,
                slidesPerView: 1,
                pagination: {
                    el: pagination,
                    clickable: true
                },
                navigation: {
                    nextEl: buttonNext,
                    prevEl: buttonPrev,
                },
                on: {
                    slideChange: function () {
                      pauseAllYouTubeVideos();
                    }
                },
                breakpoints: {
                    992: {
                        initialSlide: 0,
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                        spaceBetween: 0,
                        centeredSlides: false,
                    }
                }
            });
        });
    }

    const imageModal = document.querySelectorAll( '.modal-image-swiper' );
    if ( Object.keys(imageModal).length ) {
        imageModal.forEach(image => {
            const pagination = image.querySelector('.swiper-pagination');
            const buttonNext = image.querySelector('.swiper-button-next');
            const buttonPrev = image.querySelector('.swiper-button-prev');
            const swiperModal = new Swiper( image , {
                modules: [Pagination],
                direction: 'horizontal',
                spaceBetween: 20,
                slidesPerView: 1,
                pagination: {
                    el: pagination,
                    clickable: true
                },
                navigation: {
                    nextEl: buttonNext,
                    prevEl: buttonPrev,
                },
                on: {
                    slideChange: function () {
                      pauseAllYouTubeVideos();
                    }
                },
                breakpoints: {
                    992: {
                        initialSlide: 0,
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                        spaceBetween: 0,
                        centeredSlides: false,
                    }
                }
            });
        });
    }


    // Pause videos on swiper change
    function pauseAllYouTubeVideos() {
        const videos = document.querySelectorAll('video');
        videos.forEach(video => {
            video.pause(); // Pauses the video
        });
    }

    // Reset video on modal close
    document.querySelectorAll('.modal').forEach(modal => {
        modal.addEventListener('hidden.bs.modal', function () {
            modal.querySelectorAll('video').forEach(video => {
                video.pause();  // Pause the video
                video.currentTime = 0;  // Reset to the beginning
            });
        });
    });



    // Safe DOM element queries
    document.querySelectorAll('.adoption-carousel').forEach((adoptionSec) => {
        let filterAge = adoptionSec.querySelector('.filter-age');
        let filterGender = adoptionSec.querySelector('.filter-gender');
        let filterSize = adoptionSec.querySelector('.filter-size');
        let submitBtn = adoptionSec.querySelector('.filter-submit');
        let resetBtn = adoptionSec.querySelector('.filter-reset');
    
        let adoptionGrid = adoptionSec.querySelector('.adoption-grid');
        let adoptionGridBlocks = adoptionGrid ? adoptionGrid.querySelectorAll('.adoption-grid__block') : [];
    
        let adoptionSwiper = adoptionSec.querySelector('.swiper-adoption-carousel');
        let adoptionSwiperBlocks = adoptionSwiper ? adoptionSwiper.querySelectorAll('.swiper-slide') : [];
    
        // Filter validation functions
        function areAllFiltersSelected() {
            return filterAge?.value && filterSize?.value && filterGender?.value;
        }
    
        // Enable/disable submit buttons
        function updateSubmitButtonState() {
            if (submitBtn) {
                submitBtn.disabled = !areAllFiltersSelected();
            }
        }
    
        // Filter logic
        function filterDogs(gridBlocks) {
            gridBlocks.forEach(block => {
                const matches =
                    block.getAttribute('data-age') === filterAge?.value &&
                    block.getAttribute('data-gender') === filterGender?.value &&
                    block.getAttribute('data-size') === filterSize?.value;
                block.style.display = matches ? 'block' : 'none';
            });
            if (typeof swiperAdoption !== 'undefined') {
                swiperAdoption.slideTo(0, 500);
            }
        }
    
        // Show all blocks
        function showAllDogs(blocks) {
            blocks.forEach(block => {
                block.style.display = 'block';
            });
        }
    
        // Reset logic
        function resetFilters() {
            if (filterAge) filterAge.selectedIndex = 0;
            if (filterGender) filterGender.selectedIndex = 0;
            if (filterSize) filterSize.selectedIndex = 0;

            updateSubmitButtonState();

            showAllDogs(adoptionGridBlocks);
            showAllDogs(adoptionSwiperBlocks);

            if (swiperAdoption && swiperAdoption.update) {
                setTimeout(() => {
                    swiperAdoption.update();
                    swiperAdoption.slideTo(0, 500);
                }, 50);
            }
        }
    
        // Event listeners (safely)
        [filterAge, filterSize, filterGender].forEach(select => {
            if (select) {
                select.addEventListener('change', updateSubmitButtonState);
            }
        });
    
        if (submitBtn) {
            submitBtn.addEventListener('click', function () {
                filterDogs(adoptionGridBlocks);
                filterDogs(adoptionSwiperBlocks);
            });
        }
    
        if (resetBtn) {
            resetBtn.addEventListener('click', function () {
                resetFilters();
            });
        }
    });

}


// Image Carousel
// const imageCarouselSwiper = document.querySelectorAll( '.swiper-image-carousel' );
// let swiperImage;
// // loop through swiper sections and init Swiper
// if ( Object.keys(imageCarouselSwiper).length ) {
//     imageCarouselSwiper.forEach( function( el ){
//         const buttonNext = el.querySelector('.swiper-button-next');
//         const buttonPrev = el.querySelector('.swiper-button-prev');
//         swiperImage = new Swiper( el , {
//             direction: 'horizontal',
//             spaceBetween: 20,
//             slidesPerView: "auto",
//             loop: false,
//             initialSlide: 0,
//             navigation: {
//                 nextEl: buttonNext,
//                 prevEl: buttonPrev,
//             },
//         })  
//     });
// }

export default AdoptionCarousel;   